export const USER_SESSION_STORAGE_KEY = "swiftcreditUserSession";

const safeParse = (value) => {
  if (!value) {
    return {};
  }

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const loadUserSession = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return safeParse(window.localStorage.getItem(USER_SESSION_STORAGE_KEY));
};

export const saveUserSession = (nextData) => {
  if (typeof window === "undefined") {
    return;
  }

  const previous = loadUserSession();
  const merged = {
    ...previous,
    ...nextData,
  };

  window.localStorage.setItem(USER_SESSION_STORAGE_KEY, JSON.stringify(merged));
};

export const clearUserSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(USER_SESSION_STORAGE_KEY);
};
